import { render, staticRenderFns } from "./ActiveConversations.vue?vue&type=template&id=1c7bb366"
import script from "./ActiveConversations.vue?vue&type=script&lang=js"
export * from "./ActiveConversations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports